import { render } from "./Navigation.vue?vue&type=template&id=f3a975c2"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=f3a975c2&lang=css"

import exportComponent from "/home/patrick/Documents/olympe/marketplace/templates/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/web/Carousel/Navigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3a975c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3a975c2', __exports__)) {
    api.reload('f3a975c2', __exports__)
  }
  
  module.hot.accept("./Navigation.vue?vue&type=template&id=f3a975c2", () => {
    api.rerender('f3a975c2', render)
  })

}


export default __exports__